// nome e cor de cada tipo de alerta mostrado no dashboard (e-mails de alerta + alertas de conducao)
export const TIPOS_ALERTA: Record<string, { label: string; cor: string }> = {
  alerta_regra:      { label: 'Regra de alerta',    cor: 'var(--color-info)' },
  movimento_alerta:  { label: 'Movimento',          cor: 'var(--color-info)' },
  anomalia_bloqueio: { label: 'Anomalia de bloqueio', cor: 'var(--color-danger)' },
  manutencao_alerta: { label: 'Manutenção',         cor: 'var(--color-chart-5)' },
  colisao:           { label: 'Colisão',            cor: 'var(--color-danger)' },
  corte_energia:     { label: 'Corte de energia',   cor: 'var(--color-warning)' },
  frenagem_brusca:   { label: 'Frenagem brusca',    cor: 'var(--color-warning)' },
  aceleracao_brusca: { label: 'Aceleração brusca',  cor: 'var(--color-warning)' },
  curva_brusca:      { label: 'Curva brusca',       cor: 'var(--color-warning)' },
}
export const rotuloAlerta = (tipo: string) => TIPOS_ALERTA[tipo]?.label || tipo
export const corAlerta = (tipo: string) => TIPOS_ALERTA[tipo]?.cor || 'var(--color-muted-foreground)'
